export enum RadioItemType {
    TEXT = 'text',
    IMAGE = 'image'
}

export interface RadioItem {
    type: RadioItemType;
    text: string;
    src?: string;
} 